import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=23e60196"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=23e60196&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports